export default "__VITE_ASSET__B2pskKQU__"